import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faMinus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Breadcrumbs from '../../components/Breadcrumbs';
import Container from '../../components/ui/Container';
import { Link } from '../../components/ui/Link';
import Panel from '../../components/ui/Panel';
import DefaultLayout from '../../layouts/DefaultLayout';

const breadcrumbLinks = [
  { name: 'Home', linkTo: '/' },
  { name: 'Voorwaarden reviews', linkTo: '/home/voorwaardenbeoordeling' },
];
// eslint-disable-next-line import/prefer-default-export
export const ReviewTermsPage: React.FC = () => (
  <DefaultLayout breadcrumbs={<Breadcrumbs links={breadcrumbLinks} />}>
    <Container state="defaultLayoutFirst">
      <Panel className="w-full md:w-2/3" position="last">
        <div>
          <h1 className="mb-[20px] font-avantgarde text-[32px] font-bold text-blue-900">
            Spelregels voor reviews
          </h1>
        </div>
        <div className="border-b-2 border-stone-100 pb-[24px]">
          <h2 className="mb-[24px] font-avantgarde text-[24px] font-bold text-blue-700">
            Criteria
          </h2>
          <p className="font-roboto text-[18px] font-normal text-stone-800">
            Wij hechten veel waarde aan de onafhankelijkheid en betrouwbaarheid
            van onze reviews. Om dit te waarborgen worden alle reviews
            individueel gecontroleerd.
          </p>
          <br />
          <p className="mb-[10px] font-roboto text-[16px] font-bold text-stone-800">
            Advieskeuze verwerkt Persoonsgegevens voor de volgende doeleinden:
          </p>
          <p className="font-roboto text-[16px] font-normal text-stone-800">
            <div className="mb-[10px] grid grid-cols-[1fr_116fr]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Reviews zijn volledig ingevuld en bevatten een toelichting.
              </div>
            </div>
            <div className="mb-[10px] grid grid-cols-[1fr_116fr]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>Reviews bevatten geen grof of beledigend taalgebruik.</div>
            </div>
            <div className="mb-[10px] grid grid-cols-[1fr_116fr]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Reviews bevatten geen reclame-uitingen of persoonsgegevens.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Reviews zijn niet geschreven door personen die een belang hebben
                in of bij de beoordeelde partij. Bijvoorbeeld: eigenaren,
                (oud-)werknemers, familieleden, etc.
              </div>
            </div>
          </p>
        </div>
        <div className="mt-[24px]">
          <h2 className="mb-[24px] font-avantgarde text-[24px] font-bold text-blue-700">
            Meer informatie
          </h2>
          <p className="font-roboto text-[16px] font-normal text-stone-800">
            Je kunt meer lezen over het handhaven van deze criteria in ons{' '}
            <span className="text-blue-500 underline">
              <a href="/home/reviewbeleid">
                beleid omtrent reviews op Advieskeuze
              </a>
            </span>
            . Met het aanvinken van de verklaring aan het einde van een review,
            ga je akkoord met de voorwaarden en geef je aan dat je jouw review
            correct, nauwkeurig en oprecht hebt ingevuld.
          </p>
          <br />
          <p className="font-roboto text-[16px] font-normal text-stone-800">
            Indien je het niet eens bent met een review, dan kun je dit tot één
            jaar nadat de review is geplaatst op Advieskeuze kenbaar maken.
            Dienstverleners kunnen dit doen via het{' '}
            <span className="text-blue-500 underline">
              <a
                href="https://extranet.advieskeuze.nl/account/logon?ReturnUrl=%2F%3F_gl%3D1%2A11k9q3c%2A_ga%2AMzU1MDA1MzgzLjE3MDg1MTkwNzQ.%2A_ga_GLWG0ECC9J%2AMTcxNTc1MzQ0OC4xODMuMS4xNzE1NzU1MjU1LjU1LjAuMA..&_gl=1*11k9q3c*_ga*MzU1MDA1MzgzLjE3MDg1MTkwNzQ.*_ga_GLWG0ECC9J*MTcxNTc1MzQ0OC4xODMuMS4xNzE1NzU1MjU1LjU1LjAuMA.."
                target="_blank"
              >
                extranet
              </a>
            </span>
            . Consumenten kunnen via het{' '}
            <span className="text-blue-500 underline">
              <a href="/home/contact">contactformulier</a>
            </span>{' '}
            of per post [Dahliastraat 94 A, 4613 DP te Bergen op Zoom] contact
            met ons opnemen.
          </p>
          <br />
          <p className="font-roboto text-[16px] font-normal text-stone-800">
            Bekijk voor meer informatie ons{' '}
            <span className="text-blue-500 underline">
              <a href="/home/reviewbeleid">
                beleid omtrent reviews op Advieskeuze
              </a>
            </span>{' '}
            of de{' '}
            <span className="text-blue-500 underline">
              <a href="/home/faq">veelgestelde vragen</a>
            </span>
            .
          </p>

          <Link
            title="Veelgestelde vragen"
            href={`/home/faq`}
            variant="default"
          >
            Veelgestelde vragen
            <FontAwesomeIcon icon={faChevronRight as IconProp} />
          </Link>
        </div>
      </Panel>
    </Container>
  </DefaultLayout>
);
